import apiCall from './apiRequest';
import endPoints from './endpoints';
import config from 'config';

function getFormattedAddress(addressInfo) {
  const details = {
    ...addressInfo,
    country: addressInfo.user_country.value,
    state: addressInfo.region.value,
    firstName: addressInfo.first_name,
    lastName: addressInfo.last_name,
    phoneNumber: addressInfo.phone_number,
    zipCode: addressInfo.zip_code,
    extendedAddress: addressInfo.extended_address
  };
  if (!details.extendedAddress) {
    delete details.extendedAddress;
  }
  if (!details.state) {
    delete details.state;
  }
  if (!details.zipCode) {
    delete details.zipCode;
  }
  delete details.region;
  delete details.user_country;
  delete details.first_name;
  delete details.last_name;
  delete details.phone_number;
  delete details.extended_address;
  delete details.zip_code;
  return details;
}

function getAddressPayload(addressDetails) {
  const { info: { addressInfo: { shipping_address, billing_address } } } = addressDetails;
  return {
    shippingAddress: getFormattedAddress(shipping_address),
    billingAddress: getFormattedAddress(billing_address)
  };
}

export function checkoutAddressSubscriptionActivateApi(addressInfo) {
  return Promise.resolve(addressInfo);
}

export function checkoutPaymentSubscriptionActivateApi(details) {
  const { activationCode, token, addressDetails } = details;
  const { shippingAddress, billingAddress } = getAddressPayload(addressDetails);
  const payload = {
    tokenId: token,
    shippingAddress,
    billingAddress
  };
  const { API } = config;

  return apiCall({
    method: 'post',
    url: `${API.fastApi}/${endPoints.me.redemption}/${activationCode}/activation`,
    payload
  });
}



// WEBPACK FOOTER //
// ./src/api/subscriptionActivate.js